<i class="{{icon}} {{iconCssClasses}}" *ngIf="icon"></i>
<h3><span [countUp]="stats" [options]="options!">{{stats | number}}</span></h3>
<p class="text-muted mb-0 {{labelCssClasses}}">{{label}}</p>